import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/** Determines which visual variant / copy the modal renders. */
export type OfflineModalVariant = 'network' | 'emergency';

/** Per-variant i18n key configuration. */
interface VariantConfig {
  titleKey: string;
  messageKey: string;
  subMessageKey?: string;
}

const VARIANT_CONFIG: Record<OfflineModalVariant, VariantConfig> = {
  network: {
    titleKey: 'connectivity.offlineTitle',
    messageKey: 'connectivity.offlineMessage',
  },
  emergency: {
    titleKey: 'connectivity.emergencyTitle',
    messageKey: 'connectivity.emergencyMessage',
    subMessageKey: 'connectivity.emergencySubMessage',
  },
};

@Component({
  selector: 'app-offline-connectivity-modal',
  templateUrl: './offline-connectivity-modal.component.html',
  styleUrls: ['./offline-connectivity-modal.component.scss'],
  standalone: false,
})
export class OfflineConnectivityModalComponent {
constructor() {}
  /** Controls which copy (title/message) is rendered. Defaults to 'network'. */
  @Input() variant: OfflineModalVariant = 'network';

  get titleKey(): string {
    return VARIANT_CONFIG[this.variant].titleKey;
  }

  get messageKey(): string {
    return VARIANT_CONFIG[this.variant].messageKey;
  }

  get subMessageKey(): string | undefined {
    return VARIANT_CONFIG[this.variant].subMessageKey;
  }
}